import expiredLink from '../components/ExpiredLink/zh.i18n.json'
import pageNotFound from '../components/PageNotFound/zh.i18n.json'
import unexpectedError from '../components/UnexpectedError/zh.i18n.json'

export default {
  pageNotFound,
  unexpectedError,
  expiredLink,
}
